import * as React from 'react'

import { validatePasswordHint, TextInput, useFormsContext } from '@ally/forms'
import { BadWords } from '@ally/use-validation'
import { toSentenceCase } from '@ally/ally-login'

import { InputWrapper, StyledInputFieldSectionContainer } from '../Shared'
import { InputFieldRuleHelper } from '../InputFieldRuleHelper'

interface PasswordHintProps {
  title: string
  badWords: BadWords
  dataTestId?: string
}

export const PasswordHint: React.FC<PasswordHintProps> = ({
  title,
  badWords,
  dataTestId,
}) => {
  const {
    values: { password, passwordHint },
  } = useFormsContext<Record<string, string>>()

  const validatePasswordHintWrapper = (
    passwordHintInput: string,
  ): string | undefined =>
    validatePasswordHint(passwordHintInput, password, badWords)

  const isHintValid = (passwordHintInput: string): boolean =>
    Boolean(
      passwordHintInput &&
        password &&
        !passwordHintInput.toLocaleLowerCase().includes(password.toLowerCase()),
    )

  const passwordHintHelpDirections = [
    {
      text: "Can't be or contain your password",
      isValid: isHintValid,
    },
  ]

  return (
    <StyledInputFieldSectionContainer>
      <InputWrapper>
        <TextInput
          labelContent={toSentenceCase(title)}
          inputType="text"
          validate={validatePasswordHintWrapper}
          name="passwordHint"
          data-allytmfn="passwordHint"
          isPrivate
          className="password-hint"
          required
          data-testid={dataTestId}
        />
      </InputWrapper>
      <InputFieldRuleHelper
        directions={passwordHintHelpDirections}
        fieldInput={passwordHint}
        id="password-hint-helper"
        name="passwordHintRuleHelper"
      />
    </StyledInputFieldSectionContainer>
  )
}
